module.exports = __webpack_public_path__ + "static/media/2.d8f2ef05.svg";